<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col(span="6")
                    div
                        h2 {{ $t('edgesetting.pageTitleText') }}
                        p Manage your registered EDGE.
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :userCanCreate="false"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :viewSlotInfo="viewSlotInfo"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="hostname"
            :primarySearchKeyI18="$t('edgesetting.hostname')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','EdgesManage')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','EdgesManage')"
            :isRestartBtnDisabled="!$can('write', 'groupResourcesPermission','EdgesManage')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','EdgesManage')"
            :userCanBatchEdit="$can('write', 'groupResourcesPermission','EdgesManage')"
            :isBatchEditBtnDisabled="!$can('write', 'groupResourcesPermission','EdgesManage')"
            :batchSelector="batchSelector"
            :givenBatchSearchFilters="givenBatchSearchFilters"
            :batchSelectorWith="batchSelectorWith"
        )
            template(slot="tableUpperBtn" v-if="isAllowGroupUserRegisterEdge && $can('write', 'groupResourcesPermission','EdgesManage')")
                Button(type="primary" @click="isRegistrationInfoShown=!isRegistrationInfoShown") {{$t('rcmtable.registrationText')}}
        RegisterNodeInfoModal(:nodeType="nodeType" :isRegistrationInfoShown="isRegistrationInfoShown" :hasPermission="isAllowGroupUserRegisterEdge" @closeRegisterInfoModal="isRegistrationInfoShown = false")
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";
import CreateEdgeBtn from "@/components/EdgeSetting/CreateEdgeBtn";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import CopyText from "@/components/CopyText";
import RegisterNodeInfoModal from "@/components/NodeRegisteration/RegisterNodeInfoModal";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("CopyText", CopyText);

import NodeConnectBtn from "@/components/NodeConnectBtn";
Vue.component("NodeConnectBtn", NodeConnectBtn);

import ExplainPrivateKeys from "@/components/PoptipInfos/ExplainPrivateKeys";
Vue.component("ExplainPrivateKeys", ExplainPrivateKeys);

import EdgeSelector from "@/components/EdgeSelector";
Vue.component("EdgeSelector", EdgeSelector);

import {
    settingZoneExplain,
    groupName,
    serviceIP,
    // serviceVersion,
    connectState,
    hostname,
    isEnabled,
    action,
} from "./fields.js";

export default {
    name: "EdgeSetting",
    components: { RcmTable, TagList, CreateEdgeBtn, RegisterNodeInfoModal },
    data() {
        return {
            nodeType: "edge",
            isRegistrationInfoShown: false,
            viewSlotInfo: {
                edgeclients: [],
            },
            recordLineOptions: [],
            esIndex: "rcm-edges",
            drawerTitleKey: "hostname",
            sort: [{ modifiedDate: { order: "desc" } }],
            objectsExplanation: {},
            batchSelector: "EdgeSelector",
            givenBatchSearchFilters: [
                {
                    key: "groupName",
                    type: "string",
                    value: this.$store.state.queryGroupName,
                },
            ],
            batchSelectorWith: ["groupName", "serviceProvideType"],
        };
    },
    computed: {
        isAllowGroupUserRegisterEdge() {
            return this.$store.state.platformPlan.multiTenancyConfigs.isAllowGroupUserRegisterEdge
                ? this.$store.state.platformPlan.multiTenancyConfigs.isAllowGroupUserRegisterEdge
                : false;
        },
        sectionInfo() {
            let sectionInfo = [
                { sectionKey: "essential", isOpened: true },
                { sectionKey: "node_connect", isOpened: false },
            ];
            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`global.formSections.${e.sectionKey}`);
                return e;
            });
            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                    //   nodeConnect: {
                    //       render: (h, params) => {
                    //           return h(
                    //               "NodeConnectBtn",
                    //               {
                    //                   props: {
                    //                       nodeType: "edge",
                    //                       hostname: params.row.hostname,
                    //                       sshKeyName: params.row.nodeConnectSSHKey,
                    //                       sshUser: params.row.nodeConnectSSHUser,
                    //                       sshHost: params.row.nodeConnectSSHHost || params.row.externalIP,
                    //                       sshPort: params.row.nodeConnectSSHPort,
                    //                   },
                    //               },
                    //               ""
                    //           );
                    //       },
                    //   },
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostname(this),
                      _id: {},
                      internalIP: {},
                      externalIP: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      isEnableProxyProtocol: {},
                      usedBySlbs: {},
                      serviceIP: serviceIP(this),
                      //   serviceVersion: serviceVersion(this),
                      serviceProvideType: {},
                      customDefaultCert: {},
                      connectState: connectState(this),
                      gitSitesSuccess: {},
                      nginxIsRunning: {},
                      nginxMasterIsRunning: {},
                      lagLogBytes: {},
                      errMsg: {},
                      nodeConnectSSHKey: {},
                      nodeConnectSSHUser: {},
                      nodeConnectSSHHost: {},
                      nodeConnectSSHPort: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostname(this),
                      _id: {},
                      internalIP: {},
                      externalIP: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      isEnableProxyProtocol: {},
                      usedBySlbs: {},
                      serviceIP: serviceIP(this),
                      //   serviceVersion: serviceVersion(this),
                      //   serviceProvideType: {},
                      customDefaultCert: {},
                      connectState: connectState(this),
                      gitSitesSuccess: {},
                      nginxIsRunning: {},
                      nginxMasterIsRunning: {},
                      lagLogBytes: {},
                      errMsg: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {},
    async mounted() {
        this.$socket.emit("getedgeclients");
    },
    sockets: {
        updateedgeclients: function (clients) {
            this.viewSlotInfo.edgeclients = clients;
        },
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>
<style lang="less" scoped>
.ivu-radio-group-large .ivu-radio-border {
    height: 150px;
    .ivu-radio {
        display: none;
    }
}
.single-radio {
    display: inline-block;
    vertical-align: top;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/EdgeSetting/Page.vue